import React, { useState, useEffect } from "react";
import "./Form10.scss";
import { FiArrowRight } from "react-icons/fi";
import { connect } from "react-redux";

import { signup } from "../../../store/auth/actions";

const Form10 = (props) => {
  const [role, setRole] = useState("");

  const handleChange = (e, value) => {
    setRole(value)
  }

  const disabledBtn = () => {
    if (!role)
      return true;
    return false;
  };

  const handleSubmit = async() => {
    await props.signup({
      userId: props.userData.signupData.userId,
      role,
    });
    props.clicking();
  };
  
  return (
    <div className="Form3 w-100">
      <div className="h1">I am a ...</div>
      <div className="input-wrapper">
        <div className="radio">
          <input
            type="radio"
            id="radio-1"
            name="gender"
            className="form-control"
            value={role}
            onChange={(e) => handleChange(e, "TEACHER")}
          />
          <label className="option" htmlFor="radio-1">
            TEACHER
          </label>
        </div>
        <div className="radio">
          <input
            type="radio"
            id="radio-2"
            name="gender"
            className="form-control"
            value={role}
            onChange={(e) => handleChange(e, "STUDENT")}
          />
          <label className="option" htmlFor="radio-2">
            STUDENT
          </label>
        </div>
      </div>
      <div className="note text-muted text-left">
        I'm creating an account on behalf of my profession.
      </div>
      <div className="my-5"></div>
      <div className="d-flex justify-content-end align-items-center ">
        <button
          className="btn btn-primary rounded-3 btn-lg mt-4"
          disabled={disabledBtn()}
          onClick={()=> handleSubmit()}
        >
          Next
          <FiArrowRight className="ml-3" />
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userData: state.auth,
});

export default connect(mapStateToProps, {
  signup
})(Form10);
